import {
  Grid,
  Typography,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Box,
} from "@mui/material";
import React from "react";

const RadioOptionsMobile = ({ question, quizData, setQuizData }) => {
  return (
    <div>
      <Box
        style={{
          margin: "10% 0 5% 0",
          display: "flex",
          justifyContent: "center",
          color: "#fff",
        }}
      >
        <Typography
          variant="h6"
          style={{ fontFamily: "Lucida Console", fontWeight: "bolder" }}
        >
          Q{question.no} - {question.ques}
        </Typography>
      </Box>

      <Grid
        container
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
        }}
      >
        <FormControl>
          <RadioGroup id={Math.random().toString(36).slice(2, 7)}>
            {question.options.map((radioOption) => (
              <FormControlLabel
                id={radioOption}
                value={question.no + "_" + radioOption}
                control={
                  <Radio
                    style={{
                      color: "white",
                    }}
                    checked={
                      quizData.questions["q" + question.no][question.title] ===
                      radioOption
                    }
                    onChange={(event) => {
                      const arr = event.target.value.split("_");
                      const qno = arr[0];
                      const val = arr[1];
                      setQuizData({
                        ...quizData,
                        questions: {
                          ...quizData.questions,
                          [`q${qno}`]: {
                            ...quizData.questions[`q${qno}`],
                            [question.title]: val,
                          },
                        },
                      });
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontSize: 16,
                      fontFamily: "Lucida Console",
                    }}
                  >
                    {radioOption}
                  </Typography>
                }
                labelPlacement="left"
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Grid>

      {/* {question?.desc && (
        <Grid
          container
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "4%",
          }}
        >
          <Typography
            style={{
              backgroundColor: "lightgrey",
              margin: "auto",
              padding: "1%",
              whiteSpace: "pre-line",
              textAlign: "left",
            }}
          >
            <b>NOTE:</b> {question?.desc}
          </Typography>
        </Grid>
      )} */}
    </div>
  );
};

export default RadioOptionsMobile;
